export type WhereToPay = 1 | 2 | 3;

export const WhereToPay = {
    Origen: 1 as WhereToPay,
    Destino: 2 as WhereToPay,
    Cuenta: 3 as WhereToPay
};

export const WhereToPayLabel: { [key in WhereToPay]: string } = {
    1: 'Origen',
    2: 'Destino',
    3: 'A cuenta',
};
